// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-default-template-tsx": () => import("./../../../src/templates/DefaultTemplate.tsx" /* webpackChunkName: "component---src-templates-default-template-tsx" */),
  "component---src-templates-home-template-tsx": () => import("./../../../src/templates/HomeTemplate.tsx" /* webpackChunkName: "component---src-templates-home-template-tsx" */),
  "component---src-templates-index-template-tsx": () => import("./../../../src/templates/IndexTemplate.tsx" /* webpackChunkName: "component---src-templates-index-template-tsx" */)
}

